import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { myUtilities } from "../../Utils";

class CreditCardPaymentAPIError extends React.Component {
  render() {
    return (
      <Row>
        <Col>
        {myUtilities.accountSpecificLanguage('error.creditcard.check',
            'Something went wrong. Please check whether credit card payment is enabled for the account or not')}
        </Col>
      </Row>
    );
  }
}
export default CreditCardPaymentAPIError;
